import React from "react"
import Helmet from "react-helmet"

import Layout from "../components/layout"

const Contact = () => (
  <Layout>
    <Helmet title="Contact | Roberttables" />
    <h1>Contact Page</h1>
  </Layout>
)

export default Contact
